<template>
  <div>
    <el-form-item>
      <span slot="label">
        获取经纬度
        <el-tooltip
          class="item"
          content="开启后将在位置后面增加经纬度属性（longitude,latitude）"
          effect="dark"
          placement="top-start"
        >
          <i class="el-icon-question" />
        </el-tooltip>
      </span>
      <el-switch v-model="activeData.longAndLat" />
    </el-form-item>
    <el-form-item>
      <span slot="label">
        开启选点
        <el-tooltip class="item" content="开启后展示地图，支持手动选择位置" effect="dark" placement="top-start">
          <i class="el-icon-question" />
        </el-tooltip>
      </span>
      <el-switch v-model="activeData.selectLocation" />
    </el-form-item>
    <el-form-item>
      <span slot="label">
        禁用搜索
        <el-tooltip class="item" content="默认开启搜索，关闭后搜索框禁用" effect="dark" placement="top-start">
          <i class="el-icon-question" />
        </el-tooltip>
      </span>
      <el-switch v-model="activeData.showSerachInput" />
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'ConfigItemInputMap',
  props: ['activeData']
}
</script>

<style scoped></style>
